import 'regenerator-runtime/runtime';
import Vue from 'vue'
import App from './App.vue'
import Buefy from 'buefy'
import 'buefy/dist/buefy.min.css'
import router from './router'
import store from './store'
import VueMoment from 'vue-moment'
import 'moment/locale/es'
import VueAxios from 'vue-axios'
import Util from './util'
import Filters from './filters'
import { SpreadsheetPlugin } from '@syncfusion/ej2-vue-spreadsheet';
import { registerLicense } from '@syncfusion/ej2-base';
import('./assets/images/logofd.png')

window.addEventListener("session-expired", () => {
  localStorage.clear();
  store.commit("RESET_ALL", null, { root: true });
});

Vue.prototype.$eventHub = new Vue(); // Global event bus

//SIDEBAR
if (!localStorage.getItem('activeSidebar'))
  localStorage.setItem('activeSidebar', true)

Vue.use(VueAxios, Util.getAxiosInstance())
Vue.use(VueMoment)
Vue.use(Buefy, {
  defaultDayNames: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa'],
  defaultMonthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']
})
Vue.use(SpreadsheetPlugin);
registerLicense('ORg4AjUWIQA/Gnt2VVhjQlFaclhJXGFWfVJpTGpQdk5xdV9DaVZUTWY/P1ZhSXxRd0dhXn5fdXZUQmVVUkU=');

new Vue({
  el: '#app',
  render: h => h(App),
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js